import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import MuiDialog from '@material-ui/core/Dialog';
import DialogTitle from './DialogTitle';

const styles = theme => ({
  // MUI Dialog Classes (These need to exist in case a parent passes down styling for them)
  scrollPaper: {},
  scrollBody: {},
  container: {},
  paper: {
    borderRadius: theme.radius.md,
  },
  paperScrollPaper: {},
  paperScrollBody: {},
  paperWidthFalse: {},
  paperWidthXs: {},
  paperWidthSm: {},
  paperWidthMd: {},
  paperWidthLg: {},
  paperWidthXl: {},
  paperFullWidth: {},
  paperFullScreen: {
    borderRadius: 0,
  },
});

const Dialog = ({
  actions,
  className,
  classes,
  children,
  onClose,
  showCloseIcon,
  variant,
  primaryHeader,
  title, disableBackdropClickClosure,
  ...rest
}) => {
  const ActionsProps = {
    actions,
    onClose,
    showCloseIcon,
  };

  const TitleTextProps = {
    title,
  };

  return (
    <MuiDialog
      classes={{
        ...classes,
        root: classNames(classes.root, className, 'dialog-dialog'),
      }}
      onClose={(event, reason) => {
        if (disableBackdropClickClosure) {
          if (reason !== 'backdropClick') { // <--- Prevents closure
            onClose();
          }
        } else {
          onClose();
        }
      }}
      {...rest}
    >
      <DialogTitle
        primaryHeader={primaryHeader}
        variant={variant}
        ActionsProps={ActionsProps}
        TitleTextProps={TitleTextProps}
      />
      {children}
    </MuiDialog>
  );
};

Dialog.defaultProps = {
  actions: [],
  showCloseIcon: true,
  variant: 'default',
  primaryHeader: false,
  title: null,
  className: '',
  onClose: null,
  disableBackdropClickClosure: false,
};

Dialog.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.shape({
    action: PropTypes.string.isRequired,
    icon: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
  })),
  onClose: PropTypes.func,
  showCloseIcon: PropTypes.bool,
  variant: PropTypes.oneOf(['modern', 'default']),
  primaryHeader: PropTypes.bool,
  title: PropTypes.string,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  disableBackdropClickClosure: PropTypes.bool,
};

export default withStyles(styles)(Dialog);
